import { render, staticRenderFns } from "./STelefoneChamada.vue?vue&type=template&id=29c1aa19"
import script from "./STelefoneChamada.vue?vue&type=script&lang=js"
export * from "./STelefoneChamada.vue?vue&type=script&lang=js"
import style0 from "./STelefoneChamada.vue?vue&type=style&index=0&id=29c1aa19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports